import apiClient from "./client";

/** 水印配置 */
export interface WatermarkConfig {
  WM_USEACCOUNT_SHOW: boolean;
  WM_COMPANY_SHOW: boolean;
  WM_ACCESSDATE_SHOW: boolean;
}

/** 将后端可能返回的字符串 "true"/"false" 转为 boolean */
function toBool(v: unknown): boolean {
  if (typeof v === 'boolean') return v;
  if (typeof v === 'string') return v === 'true';
  return false;
}

/** 获取水印配置 */
export async function getWatermarkConfig(): Promise<WatermarkConfig> {
  const res = await apiClient.post("/agentconfig/getWatermarkConfig.do");
  const d = res.data;
  if (d && d.success) {
    const raw = d.data as Record<string, unknown>;
    return {
      WM_USEACCOUNT_SHOW: toBool(raw.WM_USEACCOUNT_SHOW),
      WM_COMPANY_SHOW: toBool(raw.WM_COMPANY_SHOW),
      WM_ACCESSDATE_SHOW: toBool(raw.WM_ACCESSDATE_SHOW),
    };
  }
  throw new Error(d?.info || "获取水印配置失败");
}

/** 保存水印配置 */
export async function saveWatermarkConfig(config: Partial<WatermarkConfig>): Promise<void> {
  const p = new URLSearchParams();
  if (config.WM_USEACCOUNT_SHOW !== undefined) p.append("WM_USEACCOUNT_SHOW", String(config.WM_USEACCOUNT_SHOW));
  if (config.WM_COMPANY_SHOW !== undefined) p.append("WM_COMPANY_SHOW", String(config.WM_COMPANY_SHOW));
  if (config.WM_ACCESSDATE_SHOW !== undefined) p.append("WM_ACCESSDATE_SHOW", String(config.WM_ACCESSDATE_SHOW));
  const res = await apiClient.post("/agentconfig/saveWatermarkConfig.do", p);
  const d = res.data;
  if (d && d.success) return;
  throw new Error(d?.info || "保存水印配置失败");
}
